import { render, staticRenderFns } from "./TemplateProfile.vue?vue&type=template&id=14796836"
import script from "./TemplateProfile.vue?vue&type=script&lang=js"
export * from "./TemplateProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports